import styled from 'styled-components';

export const ShopHeader = styled.div`
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  img {
    width: 11.5rem;
    height: 5.75rem;
  }

  :first-child {
    grow: 1;
  }
`;

export const DisabledShade = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.25);
`;

export const ShopWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
`

export const ShopContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const StyledShopTitle = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  font-family: "NeueMachina";
  text-transform: uppercase;;
  color: white;

  .shop-title-bold {
    font-weight: 800;
  }

  .shop-title-gold {
    color: ${({ theme }) => theme.selection};
  }
`;

export const ShopTitleMain = styled.div`
  font-size: 2.5rem;
  font-weight: 800;
`;

export const ShopTitleSecondary = styled.div`
  font-size: 1.25rem;
  font-weight: 400;
`;

export const StyledShopSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
`;

export const StyledShopSectionObjects = styled.div`
  width: 100%;
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
`;

export const ShopSectionObjectsRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: start;
  gap: 1.25rem;
  padding-bottom: 1.25rem;
`;

export const StyledShopCategory = styled.div`
  width: 30%;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  cursor: pointer;
`;

export const ShopCategoryImageWrapper = styled.div`
  transition: linear .3s;
  width: 100%;
  border: solid 2px ${({ $hovered }) => $hovered ? 'white' : 'transparent'};
`;

export const ShopCategoryImageHolder = styled.div`
  width: 100%;
  border: solid 2px ${({ theme }) => theme.buttonDark};
  height: 6rem;
  overflow: hidden;
  position: relative;
  transition: linear .3s;

  @media (max-width: 1280px) {
    height: 4.5rem;
  }
`;

export const ShopCategoryImageName = styled.div`
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: absolute;
  text-transform: uppercase;
  font-family: "NeueMachina";
  font-size: 2.75rem;
  opacity: 0.8;
  font-weight: 800;
  color: ${({ theme }) => theme.buttonDark};
`;

export const ShopCategoryName = styled.div`
  text-transform: uppercase;
  font-family: "NeueMachina";
  font-size: 1.5rem;
  font-weight: 800;
  transition: linear .3s;
  color: ${({ $hovered, theme }) => $hovered ? theme.selection : 'white'};

  @media (max-width: 1280px) {
    font-size: 1.125rem;
  }
`;

export const ShopCategoryBg = styled.img`
  transition: linear .3s;
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: absolute;
  object-fit: cover;
  scale: ${({ $hovered }) => $hovered ? '1.2' : '1'};
`;

export const ShopItemLabel = styled.div`
  top: 0;
  left: 0;
  color: black;
  font-weight: 800;
  font-family: "NeueMachina";
  font-size: 1rem;
  position: absolute;
  padding: 0.25rem; 
`;
export const ShopItemPriceLabel = styled.div`
  bottom: 0;
  right: 0;
  color: black;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.25rem;
  font-weight: 800;
  font-family: "NeueMachina";
  font-size: 1rem;
  position: absolute;
  padding: 0.25rem; 
  span {
    padding-top: 5%;
  }
`;

export const ShopItemMeta = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: start;
  gap: 0.5rem;
`;

export const ShopItemName = styled.div`
  font-family: "NeueMachina";
  font-size: 1.5rem;
  font-weight: 800;
  transition: linear .3s;
  color: ${({ $hovered, theme }) => $hovered ? theme.selection : 'white'};

  @media (max-width: 1280px) {
    font-size: 1.125rem;
  }
`;

export const ShopItemRarity = styled.div`
  font-family: "NeueMachina";
  font-size: 1rem;
  font-weight: 800;
  transition: linear .3s;
  color: ${({ $hovered, theme }) => $hovered ? theme.selection : 'white'};

  @media (max-width: 1280px) {
    font-size: 0.875rem;
  }
`;

export const ShopItemId = styled.div`
  font-family: "NeueMachina";
  font-size: 1rem;
  font-weight: 400;
  transition: linear .3s;
  color: white;
  opacity: 0.6;

  @media (max-width: 1280px) {
    font-size: 0.875rem;
  }
`;

export const ShopItemInfo = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  gap: 0.75rem;
  overflow: hidden;
`;

export const ShopItemBuy = styled.div`
  background: ${({ theme }) => theme.background};
  padding: 0.2rem 0.5rem;
  padding-top: 6px;
  font-family: "NeueMachina";
  font-size: 1.5rem;
  font-weight: 400;
  @media (max-width: 1280px) {
    font-size: 1.125rem;
  }
  animation: buy-animation-translate 0.3s cubic-bezier(0.5, 0.35, 0.15, 1) 0s 1 normal forwards;
`;

export const ShopItemBuyHolder = styled.div`
  height: 2rem;
`;
